module.exports = __webpack_public_path__ + "static/media/twitter.0eed0f64.png";